import {
  Button,
  Form,
  Image,
  Input,
  Modal,
  Popconfirm,
  Select,
  Switch,
  Table,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import plusIcon from "../../assets/img/add-button.svg";
import deletemaster from "../../assets/img/deleteMaster.svg";
import editedMaster from "../../assets/img/editedMaster.svg";
import editMaster from "../../assets/img/editMaster.svg";
import CustomSearchInput from "../common/CustomSearchInput";
import ConfigProviderWrapper from "../common/ConfigProviderWrapper";
import SortIcon from "../common/SortIcon";
import {
  actionAddTaxMaster,
  actionDeleteTaxMaster,
  actionEditTaxMaster,
  actionGetTaxMaster,
  actionGetSingleUnitMaster,
  actionUpdateTaxStatusMaster,
} from "../../store/services/taxMasterService";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { isValidSearchString } from "../helper/common-function";

const TaxMaster = () => {
  const [editableForm] = Form.useForm();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const {
    taxMasterData,
    getTaxMasterLoader,
    addTaxtMasterLoader,
    deleteTaxMasterLoader,
    updateTaxMasterLoader,
    getSingleTaxMasterData,
    updateTaxStatusMasterLoader,
  } = useSelector((state) => state.taxMaster);

  // Generating 10 items of dummy data
  const [search, setSearch] = useState("");
  const [edited, setEdited] = useState(false);
  const [editingKey, setEditingKey] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isEditing = (record) => record.tax_master_id === editingKey;

  useEffect(() => {
    dispatch(actionGetTaxMaster({ search }));
  }, []);

  //add
  const handleAddTaxMaster = (values) => {
    const req = {
      ...values,
      rate: values.rate ? parseFloat(values.rate) : null,
    };
    dispatch(actionAddTaxMaster({ values: req, handleCancel }));
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    if (isValidSearchString(value)) {
      setSearch(value);
      if (value === "") {
        dispatch(
          actionGetTaxMaster({
            search: value,
          })
        );
      }
    }
  };

  const handleBlurAndPressEnter = (e) => {
    const value = e.target.value;
    if (search && isValidSearchString(value)) {
      dispatch(
        actionGetTaxMaster({
          search: value,
        })
      );
    }
  };

  const handleSortChange = (pagination, filters, sorter) => {
    const sorterParams = {
      field: sorter.columnKey,
      order:
        sorter.order === "descend"
          ? "DESC"
          : sorter.order === "ascend"
          ? "ASC"
          : "",
    };
    dispatch(
      actionGetTaxMaster({
        search: search,
        orderByColumn: sorterParams.field,
        order: sorterParams.order,
      })
    );
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "select" ? <Select /> : <Input className="!text-[14px]" />;
    return (
      <td {...restProps} className="input-height">
        {editing ? (
          <Form.Item
            className="mb-0 editable-order"
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: ``,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          <Typography.Paragraph
            style={{ marginBottom: 0 }}
            ellipsis={{ rows: 1, expandable: false, tooltip: true }}
            className="table-cell-text"
          >
            {children}
          </Typography.Paragraph>
        )}
      </td>
    );
  };

  const edit = (record) => {
    dispatch(actionGetSingleUnitMaster(record.tax_master_id));
    setEdited(!edited);
  };

  useEffect(() => {
    if (getSingleTaxMasterData && edited) {
      editableForm.setFieldsValue({
        name: getSingleTaxMasterData.name,
        rate: getSingleTaxMasterData.rate,
      });
      setEditingKey(getSingleTaxMasterData.tax_master_id);
    }
  }, [getSingleTaxMasterData]);

  const save = async (id) => {
    try {
      const row = await editableForm.validateFields();
      const { name, rate } = row;
      const req = { name, rate: rate ? parseFloat(rate) : null };
      dispatch(actionEditTaxMaster({ id, req, setEditingKey, setEdited }));
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const columns = [
    {
      title: "Tax Name",
      dataIndex: "name",
      key: "name",
      width: "25%",
      editable: true,
      ellipsis: true,
      sorter: (a, b) => true,
      sortIcon: () => <SortIcon />,
    },
    {
      title: "Tax Rate(%)",
      dataIndex: "rate",
      key: "rate",
      width: "25%",
      editable: true,
      ellipsis: true,
      render: (data) => (data ? data : "-"),
      sorter: (a, b) => true,
      sortIcon: () => <SortIcon />,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "3",
      width: "25%",
      editable: false,
      ellipsis: true,
      render: (status, record) => {
        const isLoading =
          updateTaxStatusMasterLoader[record.tax_master_id] || false;
        return (
          <Switch
            loading={isLoading}
            defaultChecked={status === "Active"}
            onChange={(checked) => {
              const updatedStatus = checked ? "Active" : "Inactive";
              if (record?.tax_master_id) {
                dispatch(
                  actionUpdateTaxStatusMaster({
                    id: record.tax_master_id,
                    status: updatedStatus,
                  })
                );
              } else {
                console.error("undefined");
              }
            }}
          />
        );
      },
    },
    {
      title: "Action",
      key: "4",
      width: 100,
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return (
          <div className="flex items-center">
            {editable ? (
              <div className="flex items-center">
                <Typography.Link onClick={() => save(record.tax_master_id)}>
                  <img src={editMaster} alt="" />
                </Typography.Link>
              </div>
            ) : (
              <div className="flex items-center gap-x-2 justify-center">
                <Typography.Link
                  disabled={editingKey !== ""}
                  onClick={() => edit(record)}
                >
                  <img src={editedMaster} alt="" />
                </Typography.Link>
              </div>
            )}
            <div className="ml-5">
              <Popconfirm
                description="Are you sure you want to delete?"
                onConfirm={() =>
                  dispatch(
                    actionDeleteTaxMaster({
                      id: record.tax_master_id,
                      setEditingKey,
                    })
                  )
                }
              >
                <img src={deletemaster} alt="" className="cursor-pointer" />
              </Popconfirm>
            </div>
          </div>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "name" ? "input" : "input",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <div className="master-input">
      <div className="flex justify-between mt-[15px]">
        <h1 className="text-black text-[20px] font-monaSansMedium">Tax</h1>
        <div>
          <Button
            onClick={showModal}
            className="root-btn text-white hover:text-white py-5 flex-center radius"
            icon={<Image src={plusIcon} alt="PlusIcon Icon" preview={false} />}
          >
            Add Tax
          </Button>
          <Modal
            className="input-custom"
            centered
            onOk={() => handleCancel()}
            onCancel={() => handleCancel()}
            footer={false}
            width={500}
            title=""
            open={isModalOpen}
          >
            <h1 className="text-black text-[20px]  mt-[5px] font-monaSansMedium">
              Tax
            </h1>
            <Form
              form={form}
              onFinish={handleAddTaxMaster}
              initialValues={{
                status: true, // Set the default value for the "status" field to true
              }}
              layout="vertical"
              className="mt-[20px] mb-0"
            >
              <Form.Item
                name="name"
                label="Tax Name"
                className="mb-[12px]"
                size="small"
                rules={[
                  {
                    required: true,
                    message: "Please input tax name!",
                  },
                ]}
              >
                <Input
                  style={{ background: "white" }}
                  placeholder="Enter Tax Name"
                  className=" bg-white focus:bg-white active:bg-white rounded-[10px]"
                />
              </Form.Item>
              <Form.Item
                name="rate"
                label="Tax Rate"
                normalize={(value) =>
                  value &&
                  value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1")
                }
                className="mb-[12px]"
                size="small"
                rules={[
                  {
                    required: true,
                    message: "Please input tax rate!",
                  },
                  // {
                  //   validator: (_, value) => {
                  //     if (!value) {
                  //       return Promise.resolve();
                  //     }
                  //     const rate = parseFloat(value);
                  //     if (isNaN(rate) || rate < 0 || rate > 100) {
                  //       return Promise.reject(
                  //         new Error("Please input a valid percentage (0-100)!")
                  //       );
                  //     }
                  //     return Promise.resolve();
                  //   },
                  // },
                ]}
              >
                <Input
                  style={{ background: "white" }}
                  placeholder="Enter Rate"
                  className="bg-white focus:bg-white active:bg-white rounded-[10px]"
                />
              </Form.Item>

              <div className="flex justify-center mt-[40px]">
                <Form.Item className="mb-0">
                  <Button
                    onClick={handleCancel}
                    type="button"
                    className="cancel-btn  min-h-[40px] min-w-[100px]"
                  >
                    Cancel
                  </Button>
                </Form.Item>

                <div className="ml-4">
                  <Form.Item className="mb-0">
                    <Button
                      type="primary"
                      loading={addTaxtMasterLoader}
                      className="root-btn min-h-[40px] min-w-[100px]"
                      htmlType="submit"
                    >
                      Save
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </Form>
          </Modal>
        </div>
      </div>

      <div className="form-table-design mt-[15px]">
        <div className="relative">
          <div className="search-bar">
            <CustomSearchInput
              handleSearch={handleSearch}
              handleBlurAndPressEnter={handleBlurAndPressEnter}
              searchValue={search}
            />
          </div>

          <div className="pt-3 pb-[75px]">
            <Form form={editableForm} component={false}>
              <ConfigProviderWrapper>
                <Table
                  bordered
                  onChange={handleSortChange}
                  className="ant-table-padding"
                  rowKey="tax_master_id"
                  columns={mergedColumns}
                  components={{
                    body: {
                      cell: EditableCell,
                    },
                  }}
                  loading={getTaxMasterLoader}
                  dataSource={taxMasterData}
                  pagination={false}
                  rowClassName="editable-row"
                />
              </ConfigProviderWrapper>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxMaster;
